import { graphql } from "gql";

const GENERATE_TASK_QUERY = graphql(`
  query GenerateTask($input: GenerateTaskInput!) {
    generateTask(input: $input) {
      title
      description
      assignedUserId
      dueTime
      priorityType
      isLocked
    }
  }
`);

export default GENERATE_TASK_QUERY;
